<template>
  <div class="news-information">
    <el-row>
      <el-col :span="24">
        <h1 class="news-title">新闻资讯</h1>
      </el-col>
    </el-row>
    <el-row gutter="20" class="news-cards">
      <el-col
        :span="8"
        v-for="newsItem in newsItems.slice(0, 3)"
        :key="newsItem.id"
      >
        <el-card shadow="hover" class="news-card" style="cursor: pointer">
          <img
            :src="getFirstImage(newsItem)"
            alt="news-image"
            class="news-image"
            @click="goToNewsCenter(newsItem.id)"
          />
          <!-- <img  :src="(newsItem.img ? newsItem.img.split(',')[0] : '')"  class="news-image"   @click="goToNewsCenter(newsItem.id)" /> -->
          <div class="news-content" @click="goToNewsCenter(newsItem.id)">
            <h3 class="news-item-title">{{ newsItem.title }}</h3>
            <!-- <p class="news-item-description">{{ newsItem.content }}</p> -->
            <p class="news-item-description">
              {{ getPlainText(newsItem.content) }}
            </p>
            <div class="news-meta">
              <span class="news-source"
                >{{ newsItem.newspaper }} | {{ newsItem.time }}</span
              >
              <!-- <span class="news-date">{{ newsItem.time }}</span> -->
              <span class="news-views">浏览：{{ newsItem.pageView }}次</span>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="view-more">
        <a href="/news_center">查看更多新闻 ></a>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listByTYpe } from "@/api/news.js";
import { IMG_BASE_URL } from "@/utils/index.js";
export default {
  name: "NewsInformation",
  data() {
    return {
      news: [
        {
          id: 1,
          title: "变电站无人机自主巡视 “一览无遗”无死角",
          description:
            "油养京识备色太六北劳立北构得非响海求万织你况支计引土...",
          source: "华软动态",
          date: "2021-06-22 10:00:51",
          views: 2314,
          image: "https://hr2.chnsoft.com.cn/img/news1.png",
        },
        {
          id: 2,
          title: "人机结合巡视，保护电网安全无忧",
          description: "1月20日，国网河南检修公司郑州运维三班班长甘红庆在50...",
          source: "华软动态",
          date: "2021-06-22 10:00:51",
          views: 2314,
          image: "https://hr2.chnsoft.com.cn/img/news2.png",
        },
        {
          id: 3,
          title: "无人机航拍高空盘旋百余米 锁定隐蔽 违法现场",
          description:
            "“准备，起飞！”一架黑色无人机迅速升空，在百余米的高空...",
          source: "华软动态",
          date: "2021-06-22 10:00:51",
          views: 2314,
          image: "https://hr2.chnsoft.com.cn/img/news3.png",
        },
      ],
      newsItems: [],
    };
  },
  computed: {
    IMG_BASE_URL() {
      return IMG_BASE_URL;
    },
  },
  methods: {
    getNews() {
      //分页查询新闻列表请求

      listByTYpe({ type: "" }).then((res) => {
        if (res) {
          this.newsItems = res.result;
        }
      });
    },
    getFirstImage(news) {
      // 首先检查news.img字段是否有图片
      if (news.img && news.img.trim() !== "") {
        return news.img.split(",")[0];
      }

      // 如果没有，再从富文本中提取第一个图片
      const content = news.content;
      if (!content) return "";

      // 匹配<img>标签中的src属性
      const imgTagMatch = content.match(/<img\s+src="([^"]+)"/i);
      if (imgTagMatch && imgTagMatch[1]) {
        return imgTagMatch[1];
      }

      // 匹配Markdown格式的图片
      const markdownMatch = content.match(
        /!\[(.*?)\]\((data:image\/[^;]+;base64,[^)]+)\)/i,
      );
      if (markdownMatch && markdownMatch[2]) {
        return markdownMatch[2];
      }

      return "";
    },
    richContent(data) {
      // 处理富文本内容，确保图片路径正确
      if (!data) return "";

      let content = data;

      // 处理转义的HTML标签
      content = content
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");

      // 处理vue-quill生成的富文本内容
      // 移除ql-container和ql-editor包装，但保留内部内容的class属性
      content = content.replace(
        /<div class="ql-container.*?>(.*?)<\/div>/gs,
        "$1",
      );
      content = content.replace(
        /<div class="ql-editor.*?>(.*?)<\/div>/gs,
        "$1",
      );

      // 处理特殊格式的图片标记，如 ![image.png](data:image/png;base64,...)
      content = content.replace(
        /!\[(.*?)\]\((data:image\/[^;]+;base64,[^)]+)\)/gi,
        '<img src="$2" alt="$1" class="news-content-image" />',
      );

      // 处理Markdown格式
      // 加粗
      content = content.replace(/\*\*(.*?)\*\*/gi, "<strong>$1</strong>");
      // 斜体
      content = content.replace(/\*(.*?)\*/gi, "<em>$1</em>");
      // 删除线
      content = content.replace(/~~(.*?)~~/gi, "<del>$1</del>");
      // 标题 - 支持#后面有或没有空格的情况
      content = content.replace(/^#{1}\s*(.*?)$/gm, "<h1>$1</h1>");
      content = content.replace(/^#{2}\s*(.*?)$/gm, "<h2>$1</h2>");
      content = content.replace(/^#{3}\s*(.*?)$/gm, "<h3>$1</h3>");
      // 无序列表
      content = content.replace(/^\*\s(.*?)$/gm, "<li>$1</li>");
      content = content.replace(/(<li>.*?<\/li>)/gs, "<ul>$1</ul>");
      // 有序列表
      content = content.replace(/^\d+\.\s(.*?)$/gm, "<li>$1</li>");
      content = content.replace(/(<li>.*?<\/li>)/gs, "<ol>$1</ol>");
      // 段落 - 保留原始的class属性
      content = content.replace(/^(?!<h|!<|\*|\d+\.)(.*?)$/gm, (match) => {
        // 检查是否已经有HTML标签
        if (/^<.*?>/.test(match)) {
          return match;
        }
        return "<p>" + match + "</p>";
      });

      // 将\n转换为<br>标签，实现换行效果
      content = content.replace(/\n/g, "<br>");

      // 如果存在IMG_BASE_URL，并且图片路径是相对路径，则拼接完整URL
      if (this.IMG_BASE_URL) {
        // 匹配<img>标签中的src属性，保留其他属性如class
        content = content.replace(
          /<img\s+(.*?)src="([^"]+)"(.*?)>/gi,
          (match, prefix, src, suffix) => {
            // 检查是否已经是完整URL或base64
            if (!/^https?:\/\//i.test(src) && !src.startsWith("data:")) {
              // 拼接完整URL
              return (
                "<img " +
                prefix +
                'src="' +
                this.IMG_BASE_URL +
                src +
                '"' +
                suffix +
                ">"
              );
            }
            return match;
          },
        );
      }

      return content;
    },
    getPlainText(content) {
      if (!content) return "";

      let plainText = content;

      // 移除HTML标签
      plainText = plainText.replace(/<[^>]+>/g, "");

      // 移除Markdown格式的图片
      plainText = plainText.replace(/!\[(.*?)\]\(([^)]+)\)/g, "");

      // 移除Markdown格式的其他标记
      plainText = plainText.replace(/[*_~`]/g, "");

      // 移除多余的空白字符
      plainText = plainText.trim();

      return plainText;
    },
    goToNewsCenter(id) {
      // this.$router.push({path: '/news_center'});
      this.$router.push({
        path: "/news_detail",
        query: { source: id, tabLabel: "全部新闻" },
      });
    },
  },
  mounted() {
    this.getNews(); // 页面加载时调用接口
  },
};
</script>

<style lang="scss" scoped>
.news-information {
  width: 100%;
  // max-width: 1920px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
  padding: 0px 18.75%;
}

.news-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 40px;
  margin-top: 80px;
  color: #1e242a;
}

.news-cards {
  display: flex;
  justify-content: space-between;
}

.news-card {
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s;
  display: flex;
  flex-direction: column;
  /* 确保内容垂直对齐 */
  justify-content: space-between;
  /* 内容均匀分布 */
  height: 100%;
  /* 保持卡片高度一致 */
}

/* .news-card:hover {
  transform: translateY(-5px);
} */

.news-image {
  width: 100%;
  height: 22vh;
  object-fit: cover;
  border-radius: 8px;
  /* 添加圆角 */
  background-size: 100% 100%;
}

.news-content {
  padding: 20px 0px 0px;
  text-align: left;
}

.news-item-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
  /* 单行省略号 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-item-description {
  font-size: 14px;
  color: #1e242a;
  margin-bottom: 16px;
  /* 单行省略号 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-meta {
  font-size: 12px;
  color: #999;
  display: flex;
  justify-content: space-between;
}

.view-more {
  margin-top: 20px;
  margin-bottom: 80px;
}

.view-more a {
  text-decoration: none;
  color: #1e242a;
  font-size: 16px;
}

::v-deep .el-card {
  border: none;
}
::v-deep .el-tabs__item {
  /* 修改为您想要的文字大小 */
  font-weight: normal !important;
}
</style>
